import {IDashSolicitacaoFilters} from "@models/solicitacoes/dash/IDashSolicitacaoFilters.ts";
import {IApiEndpoint, IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {IDashSolicitacao} from "@models/solicitacoes/dash/IDashSolicitacao.ts";

export const _DashboardEndpoints = {
    GetSolicitacoes: (filter: IDashSolicitacaoFilters, pagination: IPagination): IApiEndpoint<IDashSolicitacao[]> => ({
        url: '/api/Dashboard/GetSolicitacoes',
        pagination: pagination,
        query: filter,
        method: "GET",
    })
}